module.exports = __webpack_public_path__ + "static/media/arrow-down.170aa9b2.svg";